
import React from 'react';
import { booleanTestIdFormatter } from "../../../utils/helpers";
import ToggleSwitch from '../../ToggleSwitch/ToggleSwitch'

const ModularBlockInstanceTitleToggle = ({ parentInfo, uniqueKey, field_metadata, onchange, testId, multiple, schema }) => {
  const formattedTestId = booleanTestIdFormatter(testId, field_metadata.is_modular_block_instance_title);
  const selectFieldTypes = ['dropdown', 'radio', 'checkbox']

  const handleChange = (event) => {
      const eventData = event.target.checked
      field_metadata.is_modular_block_instance_title = eventData
      onchange();
  }

  const shouldRender = (selectFieldTypes.includes(schema.display_type) || !multiple) && parentInfo.hasParent && parentInfo.isMulti && (parentInfo.data_type === 'blocks');

  if (!shouldRender) return null;

  return (
    <div className="mark-group-title">
      <div className='ToggleWrap'>
        <ToggleSwitch
          testId={formattedTestId}
          name={`${uniqueKey}.is_modular_block_instance_title`}
          label="Mark as Modular block title"
          checked={field_metadata.is_modular_block_instance_title || false}
          onChange={handleChange}
          labelPosition="right"
          labelColor="secondary"
        />
      </div>
    </div>
  )
}

export default ModularBlockInstanceTitleToggle;
